<template>
  <section
    v-if="mostrar"
    class="onboarding"
    :class="{ 'onboarding--open': expandido }"
  >
    <button
      type="button"
      class="onboarding__trigger"
      :aria-expanded="expandido ? 'true' : 'false'"
      aria-controls="onboarding-checklist-content"
      @click="expandido = !expandido"
    >
      <span class="onboarding__trigger-icon" aria-hidden="true">
        <i class="bi bi-list-check"></i>
      </span>
      <span class="onboarding__trigger-copy">
        <span class="onboarding__trigger-title">Primeros pasos</span>
        <span class="onboarding__trigger-progress">
          {{ completados }}/{{ total }} completados
        </span>
      </span>
      <i
        class="bi bi-chevron-down onboarding__chevron"
        :class="{ 'onboarding__chevron--open': expandido }"
        aria-hidden="true"
      ></i>
    </button>

    <div
      id="onboarding-checklist-content"
      class="onboarding__content"
      :class="{ 'onboarding__content--open': expandido }"
    >
      <div class="onboarding__content-inner">
        <div class="onboarding__panel">
          <div
            class="d-flex flex-wrap align-items-start justify-content-between gap-2 mb-3"
          >
            <div>
              <h2 class="h6 fw-semibold mb-1">
                Dejá tu tienda lista para vender
              </h2>
              <p class="small text-muted mb-0">
                {{ completados }} de {{ total }} completados ({{ porcentaje }}%)
              </p>
            </div>
            <button
              v-if="completados === total"
              type="button"
              class="btn btn-sm btn-outline-secondary rounded-pill"
              @click="ocultarLocal = true"
            >
              Ocultar
            </button>
          </div>

          <div
            class="progress mb-3 rounded-pill"
            style="height: 8px"
            role="progressbar"
            :aria-valuenow="porcentaje"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div
              class="progress-bar bg-success"
              :style="{ width: porcentaje + '%' }"
            ></div>
          </div>

          <ul class="list-unstyled mb-0 vstack gap-2">
            <li
              v-for="paso in pasos"
              :key="paso.id"
              class="onboarding__item d-flex align-items-start gap-2 py-1"
              :class="{ 'onboarding__item--done': paso.done }"
            >
              <span class="onboarding__check flex-shrink-0" aria-hidden="true">
                <i
                  v-if="paso.done"
                  class="bi bi-check-circle-fill text-success"
                ></i>
                <i v-else class="bi bi-circle text-muted"></i>
              </span>
              <div class="flex-grow-1 min-w-0">
                <div class="small fw-semibold">{{ paso.label }}</div>
                <div v-if="paso.detalle" class="small text-muted">
                  {{ paso.detalle }}
                </div>
              </div>
              <router-link
                v-if="!paso.done && paso.link && paso.accion !== 'marcar_link'"
                :to="paso.link"
                class="btn btn-sm btn-outline-dark rounded-pill flex-shrink-0"
              >
                Ir
              </router-link>
              <button
                v-else-if="!paso.done && paso.accion === 'marcar_link'"
                type="button"
                class="btn btn-sm btn-outline-dark rounded-pill flex-shrink-0"
                @click="marcarLinkCompartido"
              >
                Listo
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';

export default {
  name: 'OnboardingChecklist',
  props: {
    usuario: { type: String, required: true },
  },
  data() {
    return {
      pasos: [],
      completados: 0,
      total: 0,
      porcentaje: 0,
      ocultar: false,
      ocultarLocal: false,
      expandido: false,
      cargando: true,
    };
  },
  computed: {
    mostrar() {
      return !this.ocultar && !this.ocultarLocal && this.pasos.length;
    },
  },
  mounted() {
    this.cargar();
  },
  methods: {
    async cargar() {
      if (!this.usuario) return;
      this.cargando = true;
      try {
        const { data } = await axios.get('/onboarding', {
          params: { usuario: this.usuario },
        });
        this.pasos = data.pasos || [];
        this.completados = data.completados || 0;
        this.total = data.total || 0;
        this.porcentaje = data.porcentaje || 0;
        this.ocultar = !!data.ocultar;
      } catch (e) {
        console.warn('Onboarding:', e);
      } finally {
        this.cargando = false;
      }
    },
    async marcarLinkCompartido() {
      try {
        await axios.patch('/onboarding/marcar', {
          usuario: this.usuario,
          paso: 'link_compartido',
        });
        await this.cargar();
      } catch (e) {
        console.warn(e);
      }
    },
  },
};
</script>

<style scoped>
.onboarding {
  margin-bottom: 1rem;
}

.onboarding__trigger {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 0.7rem;
  padding: 0.75rem 0.9rem;
  border: 0;
  border-radius: 12px;
  background: linear-gradient(90deg, #2563eb 0%, #1d4ed8 100%);
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.18);
  color: #fff;
  text-align: left;
}

.onboarding__trigger:hover {
  filter: brightness(1.08);
}

.onboarding__trigger:focus-visible {
  outline: 3px solid rgba(37, 99, 235, 0.35);
  outline-offset: 3px;
}

.onboarding__trigger-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  font-size: 1.05rem;
}

.onboarding__trigger-copy {
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  flex-direction: column;
}

.onboarding__trigger-title {
  font-size: 0.95rem;
  font-weight: 700;
}

.onboarding__trigger-progress {
  font-size: 0.75rem;
  opacity: 0.86;
}

.onboarding__chevron {
  flex: 0 0 auto;
  transition: transform 0.25s ease;
}

.onboarding__chevron--open {
  transform: rotate(180deg);
}

.onboarding__content {
  display: grid;
  grid-template-rows: 0fr;
  overflow: hidden;
  transition: grid-template-rows 0.25s ease;
}

.onboarding__content--open {
  grid-template-rows: 1fr;
}

.onboarding__content-inner {
  min-height: 0;
  overflow: hidden;
}

.onboarding__panel {
  margin-top: 0.45rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
}

.onboarding__item--done .small.fw-semibold {
  color: #64748b;
  text-decoration: line-through;
}

.onboarding__check {
  width: 1.25rem;
  margin-top: 0.1rem;
}

@media (min-width: 993px) {
  .onboarding {
    position: fixed;
    right: 1.25rem;
    bottom: 1.25rem;
    z-index: 1040;
    width: min(360px, calc(100vw - 2.5rem));
    margin: 0;
  }

  .onboarding__trigger {
    width: auto;
    min-width: 215px;
    margin-left: auto;
    border-radius: 999px;
    box-shadow: 0 10px 25px rgba(37, 99, 235, 0.28);
  }

  .onboarding__content {
    position: absolute;
    right: 0;
    bottom: calc(100% + 0.65rem);
    width: 100%;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transform: translateY(8px);
    transition: grid-template-rows 0.25s ease, opacity 0.2s ease,
      transform 0.25s ease, visibility 0s linear 0.25s;
  }

  .onboarding__content--open {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
    transform: translateY(0);
    transition: grid-template-rows 0.25s ease, opacity 0.2s ease,
      transform 0.25s ease;
  }

  .onboarding__panel {
    margin-top: 0;
    padding: 1.1rem;
    box-shadow: 0 16px 38px rgba(15, 23, 42, 0.16);
  }
}
</style>
